@import '../../global/accessibility.css';
@import 'src/global/variables';
@import 'src/global/mixins';

nj-connections {
  box-sizing: border-box;
  display: block;
  font-family: FrutigerNextLight, Arial, Helvetica, sans-serif;
  position: relative;
}

nj-connections * {
  box-sizing: border-box;
}

nj-connections>div>ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: auto;
  margin-top: 20px;

  @include nj-mobile-no-padding;
}

nj-connections>div>ul>li {
  display: block;

  list-style-type: none;

  margin: 12px 0 0 0;
  border: none;
  background: $color-white;

  box-shadow: 0 0 1em $color-papyrus-white;
}

nj-connections .relative {
  position: relative;
}

nj-connections>div>ul>li:nth-child(1) {
  margin: 6px 0 0 0;
}

button {
  @include nj-button-secondary;
}

button.button--connections {
  @include nj-button--connections;
}

h3,
h2 {
  color: black;
  margin-top: 36px;
  margin-bottom: 10px;

  button {
    margin-left: 16px;
  }
}

nj-connections h2.return-journey {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 4px solid white;
  color: black;
}

@media #{$screen-min-lg} {
  button.previous {
    position: absolute;
    top: 16px;
    right: 0px;
  }
}

.centered {
  text-align: center;
}

.right {
  text-align: right;
}

.list-headers {
  margin-top: 0;
  display: none;
  flex-flow: row wrap;
  font-size: 13px;
}

@media #{$screen-min-lg} {
  .list-headers {
    display: flex;
  }
}


.list-headers div:nth-child(1) {
  width: 211px;
  padding-left: 31px;
}

.list-headers div:nth-child(2) {
  flex: auto;
  padding-left: 2px;
}

.list-headers div:nth-child(3) {
  width: 266px;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85px;
  margin: 12px auto;

  background-color: $color-white;
  box-shadow: 0 0 16px $color-papyrus-white;

  @include nj-mobile-no-padding;
}

.validation-warning--bikes {
  margin-top: 24px;
}


button.invisible {
  display: none;
}


@media #{$screen-max-lg} {
  h2.js-nj-return-journey {
    display: flex;
    justify-content: space-between;
  }
}